import React from 'react';
import { ArrowRight } from 'lucide-react';
import { FadeIn } from '../ui/FadeIn';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center py-20 px-6 overflow-hidden bg-[#0a0a0a]" data-id="element-11">
      {/* Background subtle grid or texture could go here if needed, keeping it clean for now */}

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-12">
        <div className="flex flex-col gap-8 z-10" data-id="element-13">
          <FadeIn delay={0.1} data-id="element-14">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-white tracking-tighter leading-[0.9]" data-id="element-15">
              NO TE FALTA <span className="text-blue-600" data-id="element-16">DISCIPLINA</span>.
              <br data-id="element-17" />
              TE SOBRA <span className="text-gray-400" data-id="element-18">DISTRACCIÓN</span>.
            </h1>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-19">
            <p className="text-xl md:text-2xl font-bold text-blue-500 tracking-tight" data-id="element-20">
              LOCK IN: 51 días para recuperar control (sin motivación).
            </p>
          </FadeIn>

          <FadeIn delay={0.3} className="space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed max-w-xl" data-id="element-21">
            <p data-id="element-22">
              Llegas cansado. Te dices "solo 10 minutos". Y cuando levantas la
              cabeza… se fue otra noche.
            </p>
            <p data-id="element-23">
              No porque seas flojo. No porque "te falte disciplina". Sino porque
              estás intentando ganar una guerra moderna con armas viejas:{' '}
              <strong className="text-white" data-id="element-24">voluntad</strong>.
            </p>
            <p data-id="element-25">
              Y la voluntad no sobrevive turnos, estrés, sueño malo y un
              teléfono diseñado para secuestrar tu atención.
            </p>
            <p className="font-semibold text-white border-l-4 border-blue-600 pl-4" data-id="element-26">
              LOCK IN es un sistema para gente real: empleados, turnos,
              cansancio… y aun así ambición.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} className="pt-4" data-id="element-27">
            <a href="#pricing" className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-blue-600 hover:bg-blue-700 transition-all duration-300 rounded-none tracking-wide" data-id="element-28">
              ENTRAR AL MODO LOCK IN
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-29" />
              <div className="absolute inset-0 border-2 border-white/10 group-hover:border-white/20 pointer-events-none" data-id="element-30" />
            </a>
          </FadeIn>
        </div>

        <FadeIn direction="left" delay={0.5} className="relative z-10 flex justify-center lg:justify-end" data-id="element-31">
          <div className="relative w-full max-w-md lg:max-w-full aspect-[3/4] lg:aspect-square max-h-[600px]" data-id="element-32">
            <div className="absolute inset-0 bg-blue-600/20 blur-3xl rounded-full -z-10 transform translate-x-10 translate-y-10" data-id="element-33" />
            <img src="https://cdn.magicpatterns.com/uploads/pB2zw1BtBFCGLiZvsHfJiy/LOCK_IN.png" alt="LOCK IN System PDF on tablet" className="w-full h-full object-contain drop-shadow-2xl" data-id="element-34" />
          </div>
        </FadeIn>
      </div>
    </section>;
}